



























import UsersAPI from "@/services/users";
import { UserModule } from "@/store/user";
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
@Component
export default class LangSelector extends Vue {
  @Prop({ default: null }) defaultLang!: string | null;

  created(): void {
    if (this.defaultLang) {
      UserModule.currentUser.lang = this.defaultLang;
      this.$i18n.locale = this.defaultLang;
    }
  }

  get lang(): string {
    return UserModule.currentUser.lang;
  }

  async changeLang(lang: string): Promise<void> {
    const user = UserModule.currentUser;
    user.lang = lang;
    if (user.id.length > 0) {
      await UsersAPI.updateUser(user);
    }

    UserModule.setCurrentUser(user);
    UserModule.setLang(user.lang);
    this.$i18n.locale = user.lang;
  }
}
